/* eslint-disable no-case-declarations */
import _ from 'lodash'
import { fastConcat } from 'live/lib/utils'

export function plotlyReducer(state = getInitialState(), message?: PlotlyMessage): PlotlyState {
    if (!message) return state

    switch (message.type) {
        case 'event':
            const data = state.config.data

            const newState: PlotlyState = {
                config: {
                    ...state.config,
                    data: data.filter(d => d.layer !== message.layer)
                }
            }

            message.events.forEach(e => {
                // tagging data objects with layer
                e.data.forEach(obj => (obj.layer = message.layer))

                newState.config.data = data.concat(e.data)
                newState.config.layout = _.merge({}, newState.config.layout, e.layout)
                newState.config.timestamp = e.timestamp
            })

            return newState

        // return {
        //     ...state,
        //     config: message.events.reduce((acc, cur) => {
        //         if (acc == null) acc = { ...cur }

        //         acc.layout = _.merge({}, acc?.layout ?? {}, cur?.layout ?? {})
        //         acc.data = fastConcat(acc.data ?? [], cur.data ?? [])

        //         return acc
        //     }, state.config)
        // }

        default:
            return state
    }
}

export function getInitialState(): PlotlyState {
    return {
        config: {
            data: [],
            layout: {},
            timestamp: 0
        }
    }
}
